import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  FeatureSource,
  ModelBase,
} from "@models";
import {  
  WEAPON_KEYWORD_OPTIONS,
  WeaponMasteryProperty, 
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function WeaponMasteryPropertyEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<WeaponMasteryProperty>(param_obj instanceof WeaponMasteryProperty ? param_obj : api.applyWorkingOn(new WeaponMasteryProperty()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FeatureSourceInput 
      obj={obj}
      data_type="weapon_mastery_property"
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: FeatureSource) => {
        if (changed instanceof WeaponMasteryProperty) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}
      extra_menu_options={{"Attributes": 
        <Grid
          container
          spacing={0}
          direction="row"
          size={{
            xs: 12
          }}>
          <Grid
            size={{
              xs: 12
            }}>
            There are two sets of keywords.  If both are used then at least one keyword from each must be met.
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox
              name="Required Weapon Keywords Set 1"
              options={WEAPON_KEYWORD_OPTIONS}
              values={obj.required_weapon_keyword_ids}
              multiple
              onChange={(ids: string[]) => {
                const new_obj = obj;
                new_obj.required_weapon_keyword_ids = ids;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox
              name="Required Weapon Keywords Set 2"
              options={WEAPON_KEYWORD_OPTIONS}
              values={obj.required_weapon_keyword_ids2}
              multiple
              onChange={(ids: string[]) => {
                const new_obj = obj;
                new_obj.required_weapon_keyword_ids2 = ids;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        </Grid>
      }}
    />
  );
}
